import React from 'react';

const Schedule = () => (
  <div>
    <h2 className="text-xl font-bold mb-4 text-slate-800 dark:text-slate-100">Schedule</h2>
    <div className="text-slate-600 dark:text-slate-300">Settings content for <b>Schedule</b> will go here.</div>
  </div>
);

export default Schedule; 